export default {"src":"/_next/static/media/meter-high.e79895e1.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};